import { CompleteAction } from '../../../../generated';
import type { TypePolicies } from '../../../../utils/types/TypePolicies';
import { readEntityCacheFragmentById } from '../../account-settings/utils/typePolicyUtils';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      selectedActions: {
        read: (_existing, { cache, args }) =>
          args.actionIds.map((id: any) =>
            readEntityCacheFragmentById({
              cache,
              fragment: CompleteAction,
              fragmentName: 'CompleteAction',
              selector: {
                id,
                __typename: 'Action',
              },
            })
          ),
      },
    },
  },
};
